import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=bfc0a392&scoped=true"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=bfc0a392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc0a392",
  null
  
)

export default component.exports